module.exports = __webpack_public_path__ + "img/138.438b7bb.jpg";